import React, { useContext, useState } from 'react';
import { Form, Input, Button } from 'antd';
import './Login.scss';
import { rootContext } from 'stores';
import { InfoCircleOutlined } from '@ant-design/icons';
import logo from "assets/images/logos/lg.png"

const layout = {
  wrapperCol: { span: 24 }
};
const tailLayout = {
  wrapperCol: { span: 24 }
};

const Login: React.FC = () => {
  const {
    AuthStore,
    AuthStore: {
      state: { ui }
    }
  } = useContext(rootContext);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: {
    email: string;
    password: string;
    otp_code: string;
  }) => {
    setLoading(true);
    const updatedValue = {
      ...values,
    };
    if (updatedValue.otp_code) {
      const { password, ...other } = updatedValue;
      await AuthStore.verifyOtp(other);
    } else {
      const { otp_code, ...other } = updatedValue;
      await AuthStore.onLogin(other);
    }
    setLoading(false);
  };

  if (ui.verifyingToken) {
    return (
      <div className="center-items ">
        <img alt="logo" src={logo} />
      </div>
    );
  }
  return (
    <div className="LoginStyles">
      <div className="auth_block_center">
        <div className="auth_box">
          <div className="auth_block__Logo">
            <img src={logo} alt="logo" />
          </div>
          <Form
            className="login-form"
            {...layout}
            name="basic"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please input your email!' },
                { type: 'email', message: 'Invalid Email' }
              ]}
            >
              <Input
                type="email"
                placeholder="Email"
                size="large"
                disabled={Boolean(ui.showTwoFA)}
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: 'Please input your password!' }
              ]}
            >
              <Input.Password
                placeholder="Password"
                size="large"
                disabled={Boolean(ui.showTwoFA)}
              />
            </Form.Item>

            {ui.showTwoFA && (
              <Form.Item
                help={`Enter OTP sent to ${ui.showTwoFA}`}
                name="otp_code"
                rules={[{ required: true, message: 'Please input OTP' }]}
              >
                <Input size="large" />
              </Form.Item>
            )}

            <Form.Item {...tailLayout}>
              <Button
                className="login-form-button"
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
                size="large"
              >
                Submit
              </Button>
              <p>
                <InfoCircleOutlined /> For new user your password is in your
                respective email address
              </p>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
